var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "NewTrade" },
    [
      _c("program-head", { attrs: { isNeedBack: true } }),
      _vm._v(" "),
      _vm.isSuccess
        ? _c("div", [_c("success-trade")], 1)
        : _c("div", [
            _c(
              "form",
              { staticClass: "gen-form", attrs: { "data-form": "profile" } },
              [
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("Type")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "gen-select-container " }, [
                    _c("div", { staticClass: "ui-ddbox ui-ddbox-select" }, [
                      _c("button", { staticClass: "ui-ddbtn" }, [
                        _vm.listTypes && _vm.listTypes[1] && !_vm.currentType
                          ? _c("span", { staticClass: "ui-ddbtnvalue" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.listTypes[1].name) +
                                  "\n              "
                              ),
                            ])
                          : _c("span", [_vm._v(_vm._s(_vm.currentType.name))]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-caret-down",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ui-ddbody" }, [
                        _c(
                          "div",
                          { staticClass: "ui-ddsection ui-assignedtoList" },
                          [
                            _c(
                              "ul",
                              _vm._l(_vm.listTypes, function (item, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    on: {
                                      click: function ($event) {
                                        return _vm.setType(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("Commited $")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.committed,
                        expression: "form.committed",
                      },
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.committed },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "committed", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("Start date")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.start_date,
                        expression: "form.start_date",
                      },
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.start_date },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "start_date", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("End date")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.end_date,
                        expression: "form.end_date",
                      },
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.end_date },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "end_date", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("Asset")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.asset,
                        expression: "form.asset",
                      },
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.form.asset },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "asset", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", { staticClass: "radio-title" }, [
                    _vm._v("Operation"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "radio-holder" }, [
                    _c("div", { staticClass: "radio-block" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.operation,
                            expression: "form.operation",
                          },
                        ],
                        attrs: {
                          value: "buy",
                          type: "radio",
                          id: "test1",
                          name: "radio-group",
                          checked: "",
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.operation, "buy"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.form, "operation", "buy")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "test1" } }, [_vm._v("BUY")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio-block" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.operation,
                            expression: "form.operation",
                          },
                        ],
                        attrs: {
                          value: "sell",
                          type: "radio",
                          id: "test2",
                          name: "radio-group",
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.operation, "sell"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.form, "operation", "sell")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "test2" } }, [
                        _vm._v("SELL"),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "gen-fieldset__item" }, [
                  _c("label", [_vm._v("Special price $")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.special_price,
                        expression: "form.special_price",
                      },
                    ],
                    attrs: { type: "text", name: "lastcalldate" },
                    domProps: { value: _vm.form.special_price },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "special_price", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "gen-form-post-btns" }, [
              _c("div", { staticClass: "button-holder submit-btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.createProgram.apply(null, arguments)
                      },
                    },
                  },
                  [_c("span", [_vm._v("Create")])]
                ),
              ]),
              _vm._v(" "),
              _vm.error
                ? _c("div", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.error)),
                  ])
                : _vm._e(),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gen-fieldset__item current" }, [
      _c("label", [_vm._v("Current price $")]),
      _vm._v(" "),
      _c("span", [_vm._v("(will be set automatically on creation)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }